export default "__VITE_ASSET__BGIJ8YDY__"